import { useState } from 'react'
import { Button, Form, Input, Modal, Tabs, TextArea, Toast } from 'antd-mobile'
import { useBanModalAtom } from '@/store'
import { cn, customJumpHref } from '@/utils'
import { userBanAppeal } from '@/api'
import { isSuccess } from '@/axios'

const BanModal = () => {
  const { isBanVisible, setIsBanVisible, banInfo } = useBanModalAtom()
  const [isAppealVisible, setIsAppealVisible] = useState(false)
  const [form] = Form.useForm()
  const [loading, setLoading] = useState(false)

  const handleCloseBanModal = () => {
    setIsBanVisible(false)
    customJumpHref('/home')
  }

  const handleAppealSubmit = async () => {
    try {
      const values = await form.validateFields()
      setLoading(true)
      const res = await userBanAppeal({
        email: values?.email,
        appeal_reason: values.content,
        ...banInfo[0],
        id: String(banInfo[0].id),
        user_id: String(banInfo[0].user_id),
      })
      setLoading(false)
      if (isSuccess(res)) {
        Toast.show({
          content: 'Appeal submitted successfully',
          position: 'top',
        })
        setIsAppealVisible(false)
        form.resetFields()
        handleCloseBanModal()
      }
    } catch (error) {
      setLoading(false)
      console.error(error)
    }
  }

  const modalStyle = cn(
    'g-modal-v2 [--adm-modal-z-index:2000] [&_.adm-center-popup-body]:bg-panel-bg-color [&_.adm-center-popup-body]:px-[29px] [&_.adm-modal-content]:text-start [&_.adm-modal-title]:text-[30px] [&_.adm-modal-title]:text-base-text-color [&_.adm-space-item]:w-full',
    '[&_.adm-list-item-description]:bottom-auto',
  )

  return (
    <>
      {/* 封禁提示弹窗 */}
      <Modal
        visible={isBanVisible && !isAppealVisible}
        className={modalStyle}
        showCloseButton
        onClose={handleCloseBanModal}
        title='Account restricted'
        destroyOnClose
        closeOnMaskClick={false}
        stopPropagation={['click']}
        actions={[
          {
            key: 'confirm',
            text: 'Account Appeal',
            className: '!w-full',
            onClick: () => {
              setIsAppealVisible(true)
            },
          },
        ]}
        content={
          banInfo.length > 1 ? (
            <Tabs className='[--title-font-size:26px] [&_.adm-tabs-header]:border-b-0 [&_.adm-tabs-tab-active]:!text-button-text-color [&_.adm-tabs-tab-line]:bg-button-bg [&_.adm-tabs-tab]:text-color-white-trans70'>
              {banInfo.map((item, index) => {
                return (
                  <Tabs.Tab key={`${item.type_text}_${index}`} title={item.type_text}>
                    <div className='mb-[20px]'>
                      <div className='text-color-white-trans70'>Restricted content: </div>
                      <span className='pl-[40px]'>{item.type_text || '-'}</span>
                    </div>
                    <div className='mb-[20px]'>
                      <div className='text-color-white-trans70'>Restriction duration: </div>
                      <span className='pl-[40px]'>{item.duration_text || '-'}</span>
                    </div>
                    <div>
                      <div className='text-color-white-trans70'>Reason for restriction: </div>
                      <div className='h-[20dvh] overflow-y-scroll break-words pr-[10px]'>{item.reason || '-'}</div>
                    </div>
                  </Tabs.Tab>
                )
              })}
            </Tabs>
          ) : (
            <>
              <div className='mb-[20px]'>
                <div className='text-color-white-trans70'>Restricted content: </div>
                <span className='pl-[40px]'>{banInfo[0]?.type_text || '-'}</span>
              </div>
              <div className='mb-[20px]'>
                <div className='text-color-white-trans70'>Restriction duration: </div>
                <span className='pl-[40px]'>{banInfo[0]?.duration_text || '-'}</span>
              </div>
              <div>
                <div className='text-color-white-trans70'>Reason for restriction: </div>
                <div className='h-[20dvh] overflow-y-scroll break-words pr-[10px]'>{banInfo[0]?.reason || '-'}</div>
              </div>
            </>
          )
        }
      />

      {/* 申诉表单弹窗 */}
      <Modal
        visible={isAppealVisible}
        className={cn(modalStyle, '[&_.adm-modal-footer]:hidden')}
        showCloseButton
        onClose={() => {
          form.resetFields()
          setIsAppealVisible(false)
        }}
        title='Account Appeal'
        destroyOnClose
        closeOnMaskClick={false}
        stopPropagation={['click', 'touchstart']}
        content={
          <>
            <Form
              form={form}
              layout='vertical'
              className='g-form-line [&_.adm-form-item-label]:text-base-text-color [&_.adm-form-item]:mb-[24px] [&_.adm-list-item-content]:pr-0 [&_.adm-list-item-title]:pl-[14px] [&_.adm-list-item]:pl-0'
            >
              <Form.Item
                name='email'
                label='Email'
                rules={[
                  { required: true, message: 'Please enter your email' },
                  { type: 'email', message: 'Please enter a valid email' },
                ]}
              >
                <Input placeholder='Please enter your email' className='!h-[88px] !rounded-[15px] !bg-novel-detail-button-box-color !px-[24px]' />
              </Form.Item>
              <Form.Item name='content' label='Reasons for account appeal' rules={[{ required: true, message: 'Please enter your appeal content' }]}>
                <TextArea
                  placeholder='Please enter your appeal content'
                  rows={4}
                  maxLength={500}
                  showCount
                  className='!rounded-[15px] !bg-novel-detail-button-box-color !px-[24px] !py-[20px] [&_.adm-text-area-count]:text-[20px]'
                />
              </Form.Item>
            </Form>
            <Button
              className='g-btn-v2 mt-[60px] h-[76px] w-full p-0 text-[26px]'
              onClick={() => {
                handleAppealSubmit()
              }}
              loading={loading}
            >
              Submit Appeal
            </Button>
          </>
        }
      />
    </>
  )
}

export default BanModal
